import { combineReducers } from "redux";
import * as UserProfile from "./pages/UserProfile";
import * as AwaitedRequests from "./infrastructure/awaitedRequests";
import * as DataModels from "./pages/DataModels";
import * as Applications from "./pages/Applications";
import * as AuthScreens from "./pages/AuthScreens";
import * as Users from "./pages/Users";
import * as Modal from "./components/organisms/Modal";
import * as Drawers from "./components/organisms/Drawer";
import * as BreadCrumb from "./components/organisms/BreadCrumb";
import * as Alert from "./components/organisms/Alert";
import * as Spinner from "./components/organisms/Spinner";
import * as MulesoftEndpoints from "./pages/Mulesoft";
import * as Organizations from "./pages/Organizations";

export default combineReducers({
  [UserProfile.name]: UserProfile.reducer,
  [AwaitedRequests.name]: AwaitedRequests.reducer,
  [DataModels.name]: DataModels.reducer,
  [Applications.name]: Applications.reducer,
  [AuthScreens.name]: AuthScreens.reducer,
  [Users.name]: Users.reducer,
  [Modal.name]: Modal.reducer,
  [Drawers.name]: Drawers.reducer,
  [BreadCrumb.name]: BreadCrumb.reducer,
  [Alert.name]: Alert.reducer,
  [Spinner.name]: Spinner.reducer,
  [MulesoftEndpoints.name]: MulesoftEndpoints.reducer,
  [Organizations.name]: Organizations.reducer,
});
